import {roomKey} from './roomBoardMutation';

export function occupyReadyRoom(board, lock, {hotelId, room, name, operationId, occupiedAt}) {
  if (!hotelId || !room || !operationId || (board.hotelId && board.hotelId !== hotelId))
    throw new Error('Hotel/room verify nahi hua. Form dobara kholein.');
  const existing = (board.occupiedRooms || []).find(item => roomKey(item) === room);
  if (existing?.quickOccupancyId === operationId && existing.detailsPending === true &&
      !lock.activeStayId && lock.status === 'details_pending') return board;
  if (existing || lock.activeStayId || lock.status === 'details_pending')
    throw new Error(`Room ${room} already occupied/reserved hai. Existing guest verify karein.`);
  if ((board.checkoutRooms || []).some(item => roomKey(item) === room) ||
      (board.serviceRooms || []).some(item => roomKey(item) === room) ||
      ['cleaning', 'checkout_pending', 'maintenance_hold'].includes(lock.status) || lock.lastStayId)
    throw new Error(`Room ${room} cleaning/maintenance mein hai. Pehle Mark Ready karein.`);
  const ready = (board.vacantRooms || []).find(item => roomKey(item) === room);
  if (!ready) throw new Error(`Room ${room} Ready nahi hai. Fresh board par status check karein.`);
  if (lock.hotelId && lock.hotelId !== hotelId || lock.room && roomKey(lock) !== room)
    throw new Error('Room lock hotel/room mismatch hai. Record verify karein.');
  const category = ready.category || ready.roomCategory || '';
  const guestName = String(name || '').replace(/\s+/g, ' ').trim() || 'Details Pending';
  const placeholder = {room, category, roomCategory: category, status: 'details_pending', detailsPending: true,
    quickOccupancyId: operationId, guestName, temporaryGuestName: guestName === 'Details Pending' ? '' : guestName,
    phoneNumber: '', occupiedAt, checkInAt: occupiedAt, tariff: 0, advance: 0, paidTotal: 0, balance: 0,
    foodItems: [], foodTotal: 0, foodPaidTotal: 0, laundryItems: [], laundryTotal: 0,
    extraItems: [], extraTotal: 0, payments: [], source: 'quick_room_block'};
  return {...board, vacantRooms: board.vacantRooms.filter(item => roomKey(item) !== room),
    occupiedRooms: [...(board.occupiedRooms || []), placeholder]};
}
